import { render, staticRenderFns } from "./GoodsTabbar.vue?vue&type=template&id=7bb302b6&scoped=true&"
import script from "./GoodsTabbar.vue?vue&type=script&lang=js&"
export * from "./GoodsTabbar.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTabbar.vue?vue&type=style&index=0&id=7bb302b6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb302b6",
  null
  
)

export default component.exports